export default __webpack_public_path__ + "static/media/Buildings_Hostel2.7f28b7b3.JPG";